export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10392.00f7a00b.jpg";